angular.module('impactx.websocket', []).config(function () {
});